(() => {
  const initialiseStickyAddToCart = (scope = document) => {
    scope.querySelectorAll('[data-nfg-sticky-atc]').forEach((sticky) => {
      if (sticky.dataset.nfgInitialised === 'true') return;

      const sectionId = sticky.dataset.sectionId;
      const productInfo = document.getElementById(`MainProduct-${sectionId}`);
      const stickyButton = sticky.querySelector('[data-nfg-sticky-trigger]');
      const stickyLabel = sticky.querySelector('[data-nfg-sticky-label]');
      const stickyPrice = sticky.querySelector('[data-nfg-sticky-price]');
      const stickySelection = sticky.querySelector('[data-nfg-sticky-size]');
      const selectSizeLabel = sticky.dataset.selectSizeLabel || 'Select size';
      const addLabel = sticky.dataset.addLabel || 'Add to cart';

      if (!productInfo || !stickyButton || !stickyLabel) return;

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const originalButton = () =>
        document.getElementById(`ProductSubmitButton-${sectionId}`);
      const variantInput = () =>
        productInfo.querySelector('form[data-type="add-to-cart-form"] .product-variant-id');
      const optionInputs = (name) =>
        Array.from(
          productInfo.querySelectorAll(
            `input[type="radio"][data-option-name="${name}" i]`
          )
        );
      const selectedOption = (name) =>
        productInfo.querySelector(
          `input[type="radio"][data-option-name="${name}" i]:checked`
        )?.value || '';
      const sizeFieldset = () => optionInputs('Size')[0]?.closest('fieldset');
      const sizePrompt = () =>
        sizeFieldset()?.querySelector('[data-nfg-size-prompt]');
      const priceContainer = () => productInfo.querySelector(`#price-${sectionId}`);

      const requiresSizeChoice = mobileQuery.matches && optionInputs('Size').length > 0;
      let explicitSizeChosen = !requiresSizeChoice;
      let originalButtonSeen = false;

      const currentPrice = () => {
        const container = priceContainer();
        const salePrice = container?.querySelector('.price__sale .price-item--sale');
        const regularPrice = container?.querySelector('.price__regular .price-item--regular');
        return (
          salePrice ||
          regularPrice ||
          container?.querySelector('.price-item')
        )?.textContent?.trim() || '';
      };

      const variantReady = () => {
        const input = variantInput();
        return explicitSizeChosen && Boolean(input?.value) && !input.disabled;
      };

      const clearImplicitSize = () => {
        if (!requiresSizeChoice || explicitSizeChosen) return;
        optionInputs('Size').forEach((input) => {
          input.checked = false;
        });

        productInfo
          .querySelector('.product__info-container')
          ?.classList.add('nfg-size-required');
      };

      const showSizePrompt = () => {
        const fieldset = sizeFieldset();
        const prompt = sizePrompt();
        fieldset?.classList.add('nfg-size-error');
        if (prompt) prompt.hidden = false;
        fieldset?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };

      const syncButton = () => {
        const button = originalButton();
        if (!button) return;

        clearImplicitSize();

        const ready = !requiresSizeChoice || variantReady();
        const buttonLabel = button.querySelector('span');

        if (!ready) {
          button.setAttribute('aria-disabled', 'true');
          if (buttonLabel && buttonLabel.textContent.trim() !== selectSizeLabel) {
            buttonLabel.textContent = selectSizeLabel;
          }
          stickyButton.disabled = false;
          stickyButton.setAttribute('aria-disabled', 'true');
          stickyLabel.textContent = selectSizeLabel;
        } else {
          button.removeAttribute('aria-disabled');
          stickyButton.removeAttribute('aria-disabled');
          stickyButton.disabled = button.disabled;

          if (!button.disabled && buttonLabel && buttonLabel.textContent.trim() !== addLabel) {
            buttonLabel.textContent = addLabel;
          }
          stickyLabel.textContent =
            buttonLabel?.textContent?.trim() || addLabel;
        }

        const price = currentPrice();
        if (stickyPrice && price) stickyPrice.textContent = price;

        if (stickySelection) {
          const size = explicitSizeChosen ? selectedOption('Size') : '';
          const color = selectedOption('Color');
          stickySelection.textContent = size
            ? [color, size].filter(Boolean).join(' · ')
            : selectSizeLabel;
          stickySelection.hidden = false;
        }
      };

      const scheduleSync = () => {
        syncButton();
        window.setTimeout(syncButton, 150);
        window.setTimeout(syncButton, 450);
      };

      const guardPurchase = (event) => {
        if (!requiresSizeChoice || variantReady()) return false;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!explicitSizeChosen) showSizePrompt();
        return true;
      };

      productInfo.addEventListener(
        'click',
        (event) => {
          if (event.target.closest(`#ProductSubmitButton-${sectionId}`)) {
            guardPurchase(event);
          }
        },
        true
      );

      productInfo.addEventListener(
        'submit',
        (event) => {
          if (event.target.matches('form[data-type="add-to-cart-form"]')) {
            guardPurchase(event);
          }
        },
        true
      );

      stickyButton.addEventListener('click', (event) => {
        if (guardPurchase(event)) return;
        const button = originalButton();
        if (button && !button.disabled) button.click();
      });

      productInfo.addEventListener('change', (event) => {
        if (
          event.target.matches(
            'input[type="radio"][data-option-name="Size" i]'
          )
        ) {
          explicitSizeChosen = true;
          sizeFieldset()?.classList.remove('nfg-size-error');
          const prompt = sizePrompt();
          if (prompt) prompt.hidden = true;
          productInfo
            .querySelector('.product__info-container')
            ?.classList.remove('nfg-size-required');
        }
        scheduleSync();
      });

      const button = originalButton();
      if (button) {
        new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) originalButtonSeen = true;
            const showSticky = originalButtonSeen && !entry.isIntersecting;
            sticky.classList.toggle('is-visible', showSticky);
            sticky.setAttribute('aria-hidden', showSticky ? 'false' : 'true');
          },
          { threshold: 0.15 }
        ).observe(button);
      }

      sticky.dataset.nfgInitialised = 'true';
      clearImplicitSize();
      syncButton();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () =>
      initialiseStickyAddToCart()
    );
  } else {
    initialiseStickyAddToCart();
  }

  document.addEventListener('shopify:section:load', (event) =>
    initialiseStickyAddToCart(event.target)
  );
  document.addEventListener('product-info:loaded', (event) =>
    initialiseStickyAddToCart(event.target)
  );
})();
